import PropTypes from "prop-types";
import React from "react";

const AsSeenInSingle = ({ data, sliderClassName, spaceBottomClass }) => {
  return (
    <div
      className={`single-seen-in-logo ${
        sliderClassName ? sliderClassName : ""
      } ${spaceBottomClass ? spaceBottomClass : ""}`}
    >
      <div className="team-img">
        <a href={data.link} target="_blank">
          <img
            src={process.env.PUBLIC_URL + data.image}
            alt={data.alt}
            className="img-fluid"
            width="150px"
            height="150px"
          />
        </a>
      </div>
    </div>
  );
};

AsSeenInSingle.propTypes = {
  data: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
};

export default AsSeenInSingle;
